(function (w, d) {
  'use strict';
  var STORAGE_KEY = 'leucadia.cart.v2';
  try { w.localStorage.removeItem('leucadia.cart.v1'); } catch (e) {}
  var CHANGE_EVENT = 'leucadia:cart:change';
  var OPEN_EVENT   = 'leucadia:cart:open';
  var CLOSE_EVENT  = 'leucadia:cart:close';

  function load() {
    try {
      var raw = w.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { items: [] };
      var p = JSON.parse(raw);
      if (!p || !Array.isArray(p.items)) return { items: [] };
      return p;
    } catch (e) { return { items: [] }; }
  }
  function save(state) { try { w.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {} }
  function emit() { d.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: LeucadiaCart.get() })); }
  function findIndex(items, key) { for (var i=0;i<items.length;i++) if (items[i].key===key) return i; return -1; }
  function lookupCatalog(handle) {
    try { return (w.LEUCADIA_CHL && w.LEUCADIA_CHL.lookup) ? w.LEUCADIA_CHL.lookup(handle) : null; } catch (e) { return null; }
  }
  function enrich(it) {
    var key = String(it.key || '');
    var meta = lookupCatalog(key);
    return {
      key: key,
      chlVariantId: Number(it.chlVariantId || (meta && meta.variantId) || 0),
      title: String(it.title || (meta && meta.title) || ''),
      price: Number(it.price || (meta && meta.price) || 0),
      image: String(it.image || (meta && meta.image) || ''),
      qty: Math.max(1, parseInt(it.qty || 1, 10))
    };
  }
  function backfillImages() {
    var changed = false;
    state.items.forEach(function (it) {
      if (!it.image) {
        var meta = lookupCatalog(it.key);
        if (meta && meta.image) { it.image = meta.image; changed = true; }
      }
    });
    if (changed) { save(state); emit(); }
  }
  function readCookie(name) {
    try { var m = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&') + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function getFbc() {
    var c = readCookie('_fbc');
    if (c) return c;
    try {
      var fbclid = new URLSearchParams(w.location.search).get('fbclid');
      if (fbclid) return 'fb.1.' + Date.now() + '.' + fbclid;
    } catch (e) {}
    return '';
  }
  function getFbp() { return readCookie('_fbp'); }
  function uuid() {
    return 'leu-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
  }
  function getOrCreateAttribIds() {
    var key = 'leucadia.fbids.v1';
    var existing;
    try { existing = JSON.parse(w.localStorage.getItem(key) || 'null'); } catch (e) {}
    if (!existing || !existing.atc_event_id) {
      existing = { atc_event_id: uuid(), ic_event_id: uuid(), purchase_event_id: uuid() };
      try { w.localStorage.setItem(key, JSON.stringify(existing)); } catch (e) {}
    }
    return existing;
  }
  function trackMeta(event, payload, eventId) {
    try {
      if (typeof w.fbq !== 'function') return;
      if (eventId) w.fbq('track', event, payload || {}, { eventID: eventId });
      else w.fbq('track', event, payload || {});
    } catch (e) {}
  }
  function buildAttrQs(attrs) {
    return Object.keys(attrs).filter(function (k) { return attrs[k]; }).map(function (k) {
      return 'attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(attrs[k]);
    }).join('&');
  }
  /**
   * Find the active PDP quantity input. Dawn places <quantity-input>
   * (containing <input name="quantity">) in the parent product-info
   * section, OUTSIDE the <product-form>. Look in increasing scope:
   *   1. The button's product section (data-section-id / .product / .product__info-container)
   *   2. Any quantity input on the page (assumes single-PDP page, which is true for products/* routes)
   */
  function findQtyInput(fromEl) {
    if (!fromEl) return null;
    var section = fromEl.closest('[data-section-id], section[id*="product"], .product, .product__info-container, .product__info-wrapper, main');
    if (section) {
      var inSec = section.querySelector('[name=quantity]') || section.querySelector('[data-leu-qty-input]');
      if (inSec) return inSec;
    }
    return d.querySelector('product-info [name=quantity]') || d.querySelector('quantity-input [name=quantity]') || d.querySelector('[name=quantity]') || d.querySelector('[data-leu-qty-input]');
  }

  var state = load();
  var LeucadiaCart = {
    add: function (item) {
      var clean = enrich(item);
      if (!clean.key || !clean.chlVariantId) { console.warn('[LeucadiaCart] add() requires key + chlVariantId', item); return; }
      var idx = findIndex(state.items, clean.key);
      if (idx >= 0) { state.items[idx].qty += clean.qty; if (!state.items[idx].image && clean.image) state.items[idx].image = clean.image; } else { state.items.push(clean); }
      save(state); emit();
      var ids = getOrCreateAttribIds();
      trackMeta('AddToCart', {
        content_ids: [String(clean.chlVariantId)],
        content_name: clean.title,
        content_type: 'product',
        contents: [{ id: String(clean.chlVariantId), quantity: clean.qty, item_price: clean.price }],
        value: clean.price * clean.qty,
        currency: 'USD'
      }, ids.atc_event_id);
    },
    addByHandle: function (handle, qty, overrideImage) {
      var meta = lookupCatalog(handle);
      if (!meta) { console.warn('[LeucadiaCart] No CHL mapping for handle:', handle); return; }
      this.add({ key: handle, chlVariantId: meta.variantId, title: meta.title, price: meta.price, image: overrideImage || meta.image || '', qty: qty || 1 });
    },
    /**
     * Buy Now — single-item express checkout.
     * Does NOT touch persistent cart. Generates fresh event IDs so cart
     * attribution stays separate. Fires AddToCart + InitiateCheckout with
     * matching event IDs that CHL will use for Purchase deduplication.
     */
    buyNow: function (handle, qty, overrideImage) {
      if (!handle) { console.warn('[LeucadiaCart] buyNow requires handle'); return; }
      var meta = lookupCatalog(handle);
      if (!meta || !meta.variantId) { console.warn('[LeucadiaCart] buyNow: no CHL mapping for', handle); return; }
      qty = Math.max(1, parseInt(qty || 1, 10));
      var domain = (w.LEUCADIA_CHL && w.LEUCADIA_CHL.domain) || 'coasthighwayliquor.myshopify.com';
      var atcId = uuid();
      var icId = uuid();
      var purchaseId = uuid();
      var contents = [{ id: String(meta.variantId), quantity: qty, item_price: meta.price }];
      var value = meta.price * qty;
      trackMeta('AddToCart', {
        content_ids: [String(meta.variantId)],
        content_name: meta.title,
        content_type: 'product',
        contents: contents,
        value: value,
        currency: 'USD'
      }, atcId);
      trackMeta('InitiateCheckout', {
        content_ids: [String(meta.variantId)],
        contents: contents,
        num_items: qty,
        value: value,
        currency: 'USD'
      }, icId);
      var attrs = {
        'leu_fbp': getFbp(),
        'leu_fbc': getFbc(),
        'leu_atc_event_id': atcId,
        'leu_ic_event_id': icId,
        'leu_purchase_event_id': purchaseId,
        'leu_event_source_url': w.location.origin + w.location.pathname,
        'leu_user_agent': (w.navigator && w.navigator.userAgent) ? w.navigator.userAgent.slice(0, 200) : '',
        'leu_buy_now': '1'
      };
      var qs = buildAttrQs(attrs);
      var url = 'https://' + domain + '/cart/' + meta.variantId + ':' + qty + (qs ? ('?' + qs) : '');
      setTimeout(function () { w.location.assign(url); }, 200);
      return url;
    },
    setQty: function (key, qty) {
      var idx = findIndex(state.items, key); if (idx < 0) return;
      var n = Math.max(0, parseInt(qty||0,10));
      if (n === 0) state.items.splice(idx, 1); else state.items[idx].qty = n;
      save(state); emit();
    },
    remove: function (key) { this.setQty(key, 0); },
    clear: function () { state = { items: [] }; save(state); emit(); },
    get: function () { return JSON.parse(JSON.stringify(state)); },
    count: function () { return state.items.reduce(function (n, it) { return n + it.qty; }, 0); },
    subtotal: function () { return state.items.reduce(function (s, it) { return s + (it.price * it.qty); }, 0); },
    buildCheckoutUrl: function () {
      if (!state.items.length) return null;
      var domain = (w.LEUCADIA_CHL && w.LEUCADIA_CHL.domain) || 'coasthighwayliquor.myshopify.com';
      var pairs = state.items.map(function (it) { return it.chlVariantId + ':' + it.qty; }).join(',');
      var ids = getOrCreateAttribIds();
      var attrs = {
        'leu_fbp': getFbp(),
        'leu_fbc': getFbc(),
        'leu_atc_event_id': ids.atc_event_id,
        'leu_ic_event_id': ids.ic_event_id,
        'leu_purchase_event_id': ids.purchase_event_id,
        'leu_event_source_url': w.location.origin + w.location.pathname,
        'leu_user_agent': (w.navigator && w.navigator.userAgent) ? w.navigator.userAgent.slice(0, 200) : ''
      };
      var qs = buildAttrQs(attrs);
      return 'https://' + domain + '/cart/' + pairs + (qs ? ('?' + qs) : '');
    },
    checkout: function () {
      var url = this.buildCheckoutUrl(); if (!url) return;
      var ids = getOrCreateAttribIds();
      trackMeta('InitiateCheckout', {
        content_ids: state.items.map(function (it) { return String(it.chlVariantId); }),
        contents: state.items.map(function (it) { return { id: String(it.chlVariantId), quantity: it.qty, item_price: it.price }; }),
        num_items: state.items.reduce(function (n, it) { return n + it.qty; }, 0),
        value: this.subtotal(),
        currency: 'USD'
      }, ids.ic_event_id);
      setTimeout(function () { w.location.assign(url); }, 200);
    },
    open:   function () { d.dispatchEvent(new CustomEvent(OPEN_EVENT)); },
    close:  function () { d.dispatchEvent(new CustomEvent(CLOSE_EVENT)); },
    toggle: function () { var open = d.body.classList.contains('leu-cart-open'); if (open) this.close(); else this.open(); },
    _events: { change: CHANGE_EVENT, open: OPEN_EVENT, close: CLOSE_EVENT },
    _meta: { getFbp: getFbp, getFbc: getFbc, getEventIds: getOrCreateAttribIds },
    _findQtyInput: findQtyInput
  };
  w.LeucadiaCart = LeucadiaCart;

  d.addEventListener('click', function (e) {
    /* Generic Buy Now hook for any [data-leu-buy-now] button */
    var buyBtn = e.target.closest('[data-leu-buy-now]');
    if (buyBtn) {
      e.preventDefault(); e.stopPropagation();
      if (buyBtn.hasAttribute('disabled')) return;
      var bnHandle = buyBtn.getAttribute('data-leu-handle');
      if (!bnHandle) {
        var pathMatch = w.location.pathname.match(/\/products\/([^\/?]+)/);
        if (pathMatch) bnHandle = decodeURIComponent(pathMatch[1]);
      }
      var bnQty = parseInt(buyBtn.getAttribute('data-leu-qty') || '0', 10);
      if (!bnQty) {
        var qInput = findQtyInput(buyBtn);
        if (qInput) bnQty = parseInt(qInput.value || '1', 10);
      }
      if (!bnQty || bnQty < 1) bnQty = 1;
      LeucadiaCart.buyNow(bnHandle, bnQty, buyBtn.getAttribute('data-leu-image') || '');
      return;
    }

    /* Generic ATC handler for [data-leu-atc] buttons (collection cards, etc) */
    var btn = e.target.closest('[data-leu-atc]'); if (!btn) return;
    e.preventDefault(); if (btn.hasAttribute('disabled')) return;
    var handle = btn.getAttribute('data-leu-handle');
    if (!handle && !btn.getAttribute('data-leu-variant-id')) { console.warn('[LeucadiaCart] missing handle/variant', btn); return; }
    var qty = parseInt(btn.getAttribute('data-leu-qty') || '0', 10);
    if (!qty) {
      var scope2 = btn.closest('[data-leu-pdp]') || btn.parentElement;
      var qInput2 = scope2 && scope2.querySelector('[data-leu-qty-input]');
      if (qInput2) qty = parseInt(qInput2.value || '1', 10);
    }
    if (!qty || qty < 1) qty = 1;
    var image = btn.getAttribute('data-leu-image') || '';
    var title = btn.getAttribute('data-leu-title');
    var price = parseFloat(btn.getAttribute('data-leu-price') || '0');
    var variantId = parseInt(btn.getAttribute('data-leu-variant-id') || '0', 10);
    if (variantId) {
      LeucadiaCart.add({ key: handle || ('variant-' + variantId), chlVariantId: variantId, title: title || '', price: price || 0, image: image, qty: qty });
    } else {
      LeucadiaCart.add({ key: handle, chlVariantId: 0, title: title || '', price: price || 0, image: image, qty: qty });
    }
    if (!btn.hasAttribute('data-leu-no-open')) LeucadiaCart.open();
  });

  function init() { backfillImages(); emit(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})(window, document);
